<template>
  <div class="mt-4">
    <div class="report-title mb-4">
      <h4>Check Completeness</h4>
      <b-button variant="primary" @click="$bvModal.show('warn-modal')"
        >Publish Version</b-button
      >
    </div>

    <CompletenessReport
      :statistics="statistics"
      :group-by-options="groupByOptions"
      :group-by.sync="groupBy"
      :is-busy.sync="isBusy"
    >
    </CompletenessReport>

    <b-modal
      title="Publish Version"
      id="warn-modal"
      @ok="publishVersion"
      @show="publishError = null"
      :busy="isBusyModal"
    >
      <p>
        Are you sure you want to create a new version? Patients will be using
        this new version.
      </p>
      <p>
        For publication, the completeness of answers must be 100%.
      </p>

      <b-alert class="mt-1 mb-1" :show="publishError !== null" variant="danger">
        <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
        {{ publishError }}
      </b-alert>

      <template #modal-footer>
        <div class="w-100">

          <b-button
              variant="primary"
              size="sm"
              class="float-right"
              v-if="publishError === null"
              @click="publishVersion"
          >
            Publish
          </b-button>
          <b-button
              variant="outline"
              size="sm"
              class="float-right mr-2"
              @click="hideModal"
          >
            Cancel
          </b-button>
        </div>
      </template>

      <b-overlay :show="isBusyModal" spinner-variant="primary" no-wrap>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import { HttpHandler } from "@/http/HttpHandler";
import { CompletenessStatistic } from "@/entities/CompletenessStatistic";
import CompletenessReport from "@/components/CompletenessReport.vue";
import NotificationService from "@/services/NotificationService";
import store from "@/store/index";

@Component({
  components: {
    CompletenessReport
  }
})
export default class AdminReports extends Vue {
  groupByOptions = ["Branch", "Expert", "Treatment"];
  groupBy: string = this.groupByOptions[0];
  isBusy: boolean = false;
  isBusyModal: boolean = false;
  publishError: string | null = null;

  statistics: CompletenessStatistic[] | void = [];
  notificationService: NotificationService = new NotificationService();

  @Watch("groupBy")
  async onGroupByChanged(newGroupBy: string) {
    this.groupBy = newGroupBy;
    await this.loadData();
  }

  async created() {
    await this.loadData();
  }

  async loadData() {
    const httpHandler = new HttpHandler(store);
    this.isBusy = true;
    this.statistics = await httpHandler
      .getAdminStatistic(this.groupBy)
      .catch(e => {
        this.isBusy = false;

        let errorMessage = e.data.Message;
        let errorTile = "Something goes wrong";
        this.notificationService.showError(errorMessage, errorTile);
      });

    this.isBusy = false;
  }

  async publishVersion(bvModalEvt: any) {
    bvModalEvt.preventDefault();
    this.isBusyModal = true;
    this.publishError = null;

    await new HttpHandler(store)
      .publishVersion()
      .then(() => {
        this.isBusyModal = false;

        this.$nextTick(() => {
          this.hideModal();
        });

        this.notificationService.showSuccess("New version created");
      })
      .catch((e: any) => {
        this.isBusyModal = false;
        this.publishError = e.data.Message;
      });
  }

  showModal() {
    this.$bvModal.show("warn-modal");
  }

  hideModal() {
    this.$bvModal.hide("warn-modal");
  }
}
</script>

<style scoped lang="scss">
.report-title {
  display: flex;
  justify-content: space-between;
}
</style>
